module.exports = __webpack_public_path__ + "img/512.98d90e57.png";